import { CollapsibleCheckboxListModel } from 'models/api/collapsible-checkbox-list-model';
import { handleActions } from 'redux-actions';

import {
    setCollapsibleCheckboxListError,
    setCollapsibleCheckboxListLoaded,
    setCollapsibleCheckboxListLoading,
    toggleCheckboxListItem,
    toggleMasterCheckboxItem,
    resetCollapsibleCheckboxListData,
    appendCollapsibleListData,
    appendCollapsibleListDataViaSocket,
    mergeCollapsibleListDataViaSocket,
    removeCollapsibleListDataViaSocket,
    updateCollapsibleListDataViaSocket
} from 'store/actions/common/collapsible-checkbox-list-actions';

const initialState = {};

const getCollapsibleCheckboxListModel = (state, type) => {
    return state[type] || new CollapsibleCheckboxListModel({ type });
}
export default handleActions(
    {
        [setCollapsibleCheckboxListLoading]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).setLoading(payload) };
        },
        [setCollapsibleCheckboxListLoaded]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).setLoaded(payload) };
        },
        [setCollapsibleCheckboxListError]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(payload.type).setError(payload.error) };
        },
        [toggleCheckboxListItem]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).toggleItem(payload) };
        },
        [toggleMasterCheckboxItem]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).toggleMasterItem(payload) };
        },
        [appendCollapsibleListData]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).appendCheckboxListData(payload) };
        },
        [appendCollapsibleListDataViaSocket]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).appendCheckboxListDataViaSocket(payload) };
        },
        [mergeCollapsibleListDataViaSocket]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).mergeCheckboxListDataViaSocket(payload) };
        },
        [removeCollapsibleListDataViaSocket]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).removeRecordFromCheckboxListViaSocket(payload) };
        },
        [updateCollapsibleListDataViaSocket]: (state, { payload }) => {
            return { ...state, [payload.type]: getCollapsibleCheckboxListModel(state, payload.type).updateRecordFromCheckboxListViaSocket(payload) };
        },
        [resetCollapsibleCheckboxListData]: (state, { payload }) => {
            const { [payload.type]: _, ...rest } = state;
            return { ...rest };
        },
    },
    initialState,
);
